import axios, { AxiosResponse } from 'axios'

import { env } from '@js/utils/env'
import gql from '@js/api/utils/gql'
import getStoreName from '@js/api/utils/getStoreName'
import getBearerToken from '@js/api/utils/getBearerToken'

interface SetRegisterAttestationResponse {
  data: {
    wceiSetRegisterAttestation: {
      success: boolean
    }
  }
  errors?: [{ message: string }]
}

export const SetRegisterAttestationMutation = gql`
  mutation($registrationId: Int!) {
    wceiSetRegisterAttestation(
      input: {
        registration_id: $registrationId,
        attestation: true
      }
    ) {
      success
    }
  }
`

/**
 * @throws {string}
 *
 * Will throw one error message; Magento only returns one at a time, rather than an array of all errors.
 */
export const setRegisterAttestation = async (
  payload: {
    registrationId: number,
  }): Promise<boolean | null> => {
  const bearerToken = getBearerToken()

  const { data }: AxiosResponse<SetRegisterAttestationResponse> = await axios({
    method: 'POST',
    url: env.magento.GRAPHQL_URL,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${bearerToken}`,
      Store: getStoreName(),
    },
    data: {
      query: SetRegisterAttestationMutation,
      variables: {
        registrationId: payload.registrationId,
      },
    },
  })

  if (data.errors) {
    throw data.errors[0].message
  }

  if (data.data.wceiSetRegisterAttestation) {
    return data.data.wceiSetRegisterAttestation.success
  }

  return null
}
